// removed by extract-text-webpack-plugin
module.exports = {"container":"magazines_FrDAG","header":"magazines_lurR-","title":"magazines_32OVm","close":"magazines_28wzK","content":"magazines_1NfAE","field":"magazines__y84W","label":"magazines_ZOUZv","number":"magazines_3LOCz","unit":"magazines_3yoqE","stepper":"magazines_3jsGX","step":"magazines_2-iKo","invalid":"magazines_N4p-M","select":"magazines_aiFtP","current":"magazines_1Za7z","subtitle":"magazines_xprY-","icon":"magazines_2GN3z","dropdown":"magazines_1gc9v","animation__dropdown":"magazines_5Lq_y","item":"magazines_1bgrS","footer":"magazines_cH-wD","button":"magazines_1-DNb"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/components/MagazineCustomSizeModal/styles.scss
// module id = 288
// module chunks = 1